import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Button,
  Card,
  Label,
  Input,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import check from "../../../assets/images/check.svg";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../assets/images/imageupload.svg";
import SimpleBar from "simplebar-react";
import { useSelector } from "react-redux";

const AddEquipment = () => {
  document.title = "Add Equipment | Elevated - Admin Dashboard";
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const equipId = searchParams.get("equipId");
  console.log(equipId, "equipId");
  const [gymId, setGymId] = useState(searchParams.get("gymId") || "");
  const { appRole, currentUser } = useSelector(
    (state) => state.auth.currentUser
  );

  const [equipmentFiles, setEquipmentFiles] = useState([]);

  const validationSchema = Yup.object().shape({
    equips: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .required("Name is required")
            .min(2, "Name must be at least 2 characters"),
          brand: Yup.string().required("Brand is required"),
          category: Yup.string()
            .required("Category is required")
            .min(2, "Category must be at least 2 characters"),
          file: Yup.mixed()
            .required("File is required")
            .test(
              "fileType",
              "Unsupported file format. Only images are allowed.",
              (value) =>
                value === null || // Allow null if optional
                (value instanceof File &&
                  ["image/jpeg", "image/png"].includes(value.type))
            ),
        })
      )
      .min(1, "At least one equipment is required")
      .required("Equips is required"),
  });

  const [uploadProgress, setUploadProgress] = useState(0); // Tracks completed uploads
  const [totalUploads, setTotalUploads] = useState(0); // Total number of files to upload
  const [isUploading, setIsUploading] = useState(false); // Tracks whether uploads are in progress
  const [brandData, setBrandData] = useState([]);
  const getCat = async () => {
    try {
      // Use Promise.all to handle all uploads
      const resp = await get(`${endpoints.brand}`);
      if (resp.data.success) {
        setBrandData(resp.data.data);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };
  useEffect(() => {
    getCat();
  }, []);
  const handleSubmit = async (values) => {
    const uploads = values.equips.map((equip) => {
      const formData = new FormData();
      formData.append("name", equip.name);
      formData.append("brand", equip.brand);
      formData.append("category", equip.category);
      formData.append("file", equip.file);
      // formData.append("gymId", seletedGymId);
      if (adminStatus == "true") {
        formData.append("admin", "true");
      }
      if (adminStatus == "true") {
      } else {
        if (gymId) {
          formData.append("gymId", gymId);
        } else {
          toast.error("Gym ID is missing. Please try again.", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          return;
        }
      }
      return post(endpoints.equip, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    });

    setTotalUploads(uploads.length); // Set total uploads for progress tracking
    setIsUploading(true);
    setUploadProgress(0); // Reset progress

    try {
      // Use Promise.all to handle all uploads
      await Promise.all(
        uploads.map((uploadPromise) =>
          uploadPromise.then(() => {
            setUploadProgress((prev) => prev + 1); // Update progress for each successful upload
          })
        )
      );

      toast.success(`Equipments Added Successfully`, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });

      adminStatus == "true"
        ? navigate(`/equip-listing?admin=true&type=default`)
        : navigate(
            `/equip-listing?equipId=${equipId}&gymId=${gymId}&isUpdate=true`
          );
      // navigate(`/equip-listing?gymId=${seletedGymId}`);
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      setIsUploading(false);
    }
  };
  const inputRef = useRef(null);
  const toggleDropdown = (key) => {
    setDropdownOpen((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const [seletedGymId, setSeletedGymId] = useState("");
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState({ dateRange: false });
  const gymIds = async () => {
    try {
      let endpoint;
      if (appRole === "admin") {
        endpoint = `${endpoints.gym}/admin?limit=50`;
      } else if (appRole === "gymOwner") {
        endpoint = `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`;
      } else {
        console.error("User role is not admin or gymOwner.");
        return;
      }

      const resp = await get(endpoint);

      if (resp?.data?.success) {
        const gymList = resp.data.data || [];
        setGymData(gymList);

        if (gymList.length > 0) {
          setSelectedGym(gymList[0]?.name || "Unknown Gym");
          setSeletedGymId(gymList[0]?._id || null);
        } else {
        }
      } else {
        console.error(
          "Failed to fetch gyms:",
          resp?.data?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error in fetching gyms:", error);
    }
  };
  const [adminStatus, setAdminStatus] = useState("");
  useEffect(() => {
    const equipFromParams = searchParams.get("equipId");

    const equipAdmin = searchParams.get("admin");
    if (equipAdmin) {
      setAdminStatus("true");
    }
    const gymFromParams = searchParams.get("gymId");
    if (gymFromParams) {
      setGymId(gymFromParams);
    }
  }, [location.search]);
  useEffect(() => {
    if (appRole == "gymOwner" || appRole == "gymStaff" || appRole == "admin") {
      gymIds();
    }
  }, []);
  return (
    <div className="mx-2">
      <Container fluid className="">
        <Row>
          <Card className="rounded-4 ">
            <Formik
              initialValues={{
                equips: [
                  {
                    name: "",
                    brand: "",
                    category: "",
                    file: null,
                  },
                ],
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({
                errors,
                touched,
                resetForm,
                values,
                setFieldValue,
                isSubmitting,
              }) => (
                <Form className="p-4">
                  <h3 className="primary-black ff-sora font-size-20 fw-bold">
                    Add Workout Equipment
                  </h3>

                  <FieldArray name="equips">
                    {({ insert, remove, push }) => (
                      <div>
                        {values.equips.length > 0 &&
                          values.equips.map((equip, index) => (
                            <div className="row align-items-center" key={index}>
                              <FormGroup className="col-12 col-sm-auto mb-3 ">
                                <div
                                  className="cursor-pointer overflow-hidden position-relative ff-sora font-size-16 fw-normal secondary-black rounded-5 bg-light d-flex flex-column justify-content-center align-items-center"
                                  style={{
                                    border: "1px dashed #ccc",
                                    width: "160px",
                                    height: "160px",
                                  }}
                                >
                                  {values.equips.at(index).file instanceof
                                  File ? (
                                    <div className="position-relative w-100 h-100">
                                      <img
                                        src={URL.createObjectURL(
                                          values?.equips?.at(index)?.file
                                        )}
                                        alt="Upload"
                                        className="h-100 w-100 object-fit-cover"
                                      />

                                      <button
                                        type="button"
                                        className="rounded-5 position-absolute cursor-pointer font-size-12"
                                        style={{
                                          color: "black",
                                          zIndex: 1,
                                          top: 10,
                                          right: 15,
                                        }}
                                        onClick={() => {
                                          setFieldValue(
                                            `equips.${index}.file`,
                                            null
                                          );

                                          inputRef.current.value = null;
                                        }}
                                      >
                                        ×
                                      </button>
                                    </div>
                                  ) : (
                                    <>
                                      <img
                                        src={imgupload}
                                        alt="Upload"
                                        height="40px"
                                        width="40px"
                                      />
                                      <div className="secondary-black text-center mt-2 ff-sora font-size-16 fw-normal cursor-pointer">
                                        Upload Media
                                      </div>
                                    </>
                                  )}

                                  <input
                                    ref={inputRef}
                                    type="file"
                                    accept="image/*"
                                    className="position-absolute top-0"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      opacity: 0,
                                    }}
                                    onChange={(e) => {
                                      setFieldValue(
                                        `equips.${index}.file`,
                                        e.target.files[0]
                                      );
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  name={`equips.${index}.file`}
                                  component="div"
                                  className="text-danger"
                                />
                              </FormGroup>

                              <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <Field
                                  style={{
                                    width: "100%",
                                    maxWidth: "412px",
                                    height: "56px",
                                    border: "none",
                                  }}
                                  name={`equips.${index}.name`}
                                  as={Input}
                                  placeholder="Equipment Name"
                                  className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4  ${
                                    errors.equips?.at(index)?.name &&
                                    touched.equips?.at(index)?.name
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  name={`equips.${index}.name`}
                                  component="div"
                                  className="text-danger"
                                />
                              </FormGroup>

                              <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <Field
                                  as={Input}
                                  type="select"
                                  name={`equips.${index}.brand`}
                                  className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4 ${
                                    errors.equips?.[index]?.brand &&
                                    touched.equips?.[index]?.brand
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  style={{
                                    width: "100%",
                                    maxWidth: "412px",
                                    height: "56px",
                                    border: "none",
                                  }}
                                >
                                  <option value="">Select Brand</option>
                                  {brandData.map((brand) => (
                                    <option key={brand.id} value={brand?.id}>
                                      {brand?.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name={`equips.${index}.brand`}
                                  component="div"
                                  className="text-danger"
                                />
                              </FormGroup>

                              <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <Field
                                  style={{
                                    width: "100%",
                                    maxWidth: "412px",
                                    height: "56px",
                                    border: "none",
                                  }}
                                  name={`equips.${index}.category`}
                                  as={Input}
                                  type="select"
                                  className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4  ${
                                    errors.equips?.at(index)?.category &&
                                    touched.equips?.at(index)?.category
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                >
                                  <option value="">Category</option>
                                  <option value="Cardio">Cardio</option>
                                  <option value="Strength">Strength</option>
                                  <option value="Flexibility">
                                    Flexibility
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name={`equips.${index}.category`}
                                  component="div"
                                  className="text-danger"
                                />
                              </FormGroup>
                              {index != 0 ? (
                                <div className="col mb-2">
                                  <button
                                    type="button"
                                    className="rounded-pill text-white"
                                    onClick={() => remove(index)}
                                  >
                                    X
                                  </button>
                                </div>
                              ) : (
                                <div className="col"></div>
                              )}
                            </div>
                          ))}
                        <button
                          type="button"
                          className="rounded-pill mb-2"
                          onClick={() =>
                            push({
                              name: "",
                              brand: "",
                              category: "",
                              file: "",
                            })
                          }
                        >
                          Add Another
                        </button>
                      </div>
                    )}
                  </FieldArray>
                  <div className="d-flex float-end">
                    <Button
                      type="submit"
                      className="me-2 rounded-pill"
                      disabled={isSubmitting}
                    >
                      Add Equipment
                    </Button>
                    <Button
                      color="white"
                      className="rounded-pill1"
                      onClick={() => {
                        resetForm();
                        setEquipmentFiles({ files: [] });

                        navigate(
                          `/equip-listing?equipId=${equipId}&gymId=${seletedGymId}&isUpdate=true`
                        );
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                  {isUploading && (
                    <div>
                      <p>
                        Uploading {uploadProgress} of {totalUploads}
                      </p>
                      <Progress
                        striped
                        className="my-2"
                        value={uploadProgress}
                        max={totalUploads}
                      >
                        {uploadProgress}/{totalUploads}
                      </Progress>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </Card>
        </Row>
      </Container>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </div>
  );
};

export default AddEquipment;
